/**
 * @generated SignedSource<<72bba13872435d39deead7cced87af20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserGeoInfo_user$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly country: string | null;
      readonly zipCode: string | null;
    } | null> | null;
    readonly personalAddress: {
      readonly country: string | null;
      readonly zipCode: string | null;
    } | null;
    readonly proAddress: {
      readonly country: string | null;
      readonly zipCode: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "useUserGeoInfo_user";
};
export type useUserGeoInfo_user$key = {
  readonly " $data"?: useUserGeoInfo_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserGeoInfo_user">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "zipCode",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "partialAddressCheckoutEligibility"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserGeoInfo_user",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "partialAddressCheckoutEligibility",
          "variableName": "partialAddressCheckoutEligibility"
        }
      ],
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "proAddress",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "personalAddress",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "e91b50dcf6e6f718cf15d67e7de3871a";

export default node;
